module.exports = __webpack_public_path__ + "99ed4ab15c3a5e2b43e6cb31fbf9e987.jpg";